// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const common_environment = {
  production: false,
  user: {
    api_base_url: 'https://user-dev.delivergate.com'
  },
  delivery: {
    api_base_url: 'https://platform-dev.delivergate.com'
  },
  pos: {
    api_base_url: 'https://pos-dev.delivergate.com'
  },
  report: {
    api_base_url: 'https://reporting-dev.delivergate.com'
  },
  admin: {
    api_base_url: 'https://admin-dev.delivergate.com'
  },
  webshop: {
    api_base_url: 'https://webshop-dev.delivergate.com'
  },
  reservation: {
    api_base_url: 'https://reservation-dev.delivergate.com'
  },

  CLIENT_ID: 1,
  CLIENT_SECRET: 'Q2qHmKvtE30AVkQakUTGnP60MynZCctTCOxyFdfS',
  GRANT_TYPE: 'password',

  firebase: {
    apiKey: "AIzaSyBYR5tdDMC9ZO_SHMBfaNt7iN7h70ePWwg",
    authDomain: "testdelivergate.firebaseapp.com",
    projectId: "testdelivergate",
    storageBucket: "testdelivergate.appspot.com",
    messagingSenderId: "243910031903",
    appId: "1:243910031903:web:524627d7a76f336ace332a",
    measurementId: "G-7580S8G2H6"
  },

  app_version: 'v 2.1.8'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

// export const environment = {
//     production: false,
//     user: {
//         api_base_url : 'http://musapi.kj:8888'
//     },
//     delivery: {
//         api_base_url : 'http://deliveryapi.kj:8888'
//     },
//     pos: {
//         api_base_url : 'http://pos.kj:8888'
//     },
//     report: {
//         api_base_url : 'http://reporting.kj:8888'
//     },
//     x_tenant_code: 'subway',
//     CLIENT_ID:2,
//     CLIENT_SECRET:'E8CmEdCUkrNrYpeP75NGPMkKSPuwqy9O9xzjcGYq',
//     GRANT_TYPE: 'password',
//     currency: '£',
//     currency_logo: 'pound.png',
//     store_name: 'Subway',
//     branch_name: 'Kollupitiya',
//     socket_url : '//platform.dev.delivergate.com:3444',
//     socket_channel : 'delivery_platform_service_database_action-channel-one',
//     socket_code:'2VHJ3NxiEViwouVsOq5CxSzmli8WTJhLuPilqFrVpAfDUYUwePZBwmLFuKrbhyLz'
// };
